import {
  Bot,
  SquareTerminal,
  Building2,
  Building,
  Paperclip,
  Import,
  Package,
  FileDown,
  FileText,
  Mail,
} from "lucide-react";

import { NavMain } from "@/components/nav-main";

import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/useAuth";
import logo from "/asset/logo-removebg-preview.png";
import { useCurrentActiveBranch } from "@/hooks/useCurrentActiveBranch";

const data = {
  user: {
    name: "Shi Hou",
    email: "ssXXs@example.com",
    avatar: "/avatars/shadcn.jpg",
  },
  navMain: [
    {
      title: "E Invoice",
      url: "invoices",
      icon: SquareTerminal,
      isActive: true,
      items: [
        {
          title: "Invoice",
          url: "invoice/01",
        },
        {
          title: "Credit Note",
          url: "invoice/02",
        },
        {
          title: "Debit Note",
          url: "invoice/03",
        },
        {
          title: "Refund Note",
          url: "invoice/04",
        },
        {
          title: "Self-billed Invoice",
          url: "invoice/11",
        },
        {
          title: "Self-billed CN",
          url: "invoice/12",
        },
        {
          title: "Self-billed DN",
          url: "invoice/13",
        },
        {
          title: "Self-billed RN",
          url: "invoice/14",
        },
        { title: "Consolidated Invoice", url: "invoice/01A" },
      ],
    },
    {
      title: "Downloaded E Invoices",
      url: "downloaded-e-invoices/Sales",
      icon: FileDown,
      disabled: true,
      items: [
        {
          title: "Sales",
          url: "downloaded-e-invoices/Sales",
          disabled: true,
        },
        {
          title: "Purchases",
          url: "downloaded-e-invoices/Purchases",
          disabled: true,
        },
      ],
    },
    {
      title: "Import",
      url: "import",
      icon: Import,
      items: [
        {
          title: "Import Invoices",
          url: "import",
        },
        {
          title: "Upload Records",
          url: "import/records",
        },
        {
          title: "Mapping Profiles",
          url: "mapping-profiles",
        },
      ],
    },
    {
      title: "Master",
      url: "items",
      icon: Bot,
      items: [
        {
          title: "Items",
          url: "items",
        },
        {
          title: "Buyers",
          url: "buyers",
        },
        {
          title: "Suppliers",
          url: "suppliers",
        },
        {
          title: "Job Codes",
          url: "job-codes",
        },
      ],
    },
    {
      title: "Sales Documents",
      url: "sales-documents",
      icon: FileText,
      disabled: true,
      items: [
        {
          title: "Quotations",
          url: "quotations",
          disabled: true,
        },
        {
          title: "Sales Orders",
          url: "sales-orders",
          disabled: true,
        },
        {
          title: "Delivery Orders",
          url: "delivery-orders",
          disabled: true,
        },
      ],
    },
    {
      title: "Gmail Quotation",
      url: "email-inbox",
      icon: Mail,
      items: [
        {
          title: "Email Inbox",
          url: "email-inbox",
        },
        {
          title: "Gmail Settings",
          url: "gmail-settings",
        },
      ],
    },
    {
      title: "Stock Management",
      url: "stock-transactions",
      icon: Package,
      disabled: true,
      items: [
        {
          title: "Stock Movement",
          url: "stock-transactions",
          disabled: true,
        },
        {
          title: "Stock In",
          url: "stock-in",
          disabled: true,
        },
        {
          title: "Stock Out",
          url: "stock-out",
          disabled: true,
        },
        {
          title: "Stock Adjustment",
          url: "stock-adjustment",
          disabled: true,
        },
        {
          title: "Stock History",
          url: "stock-history",
          disabled: true,
        },
        {
          title: "Stock Valuation Report",
          url: "stock-valuation",
          disabled: true,
        },
        {
          title: "Month End Stock",
          url: "month-end-stock",
          disabled: true,
        },
      ],
    },
    {
      title: "Branch",
      url: "branch",
      icon: Building,
    },
    {
      title: "Report",
      url: "report",
      icon: Paperclip,
    },
    {
      title: "Company Profile",
      url: "company",
      icon: Building2,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth();
  const { currentActiveBranch } = useCurrentActiveBranch();

  const isHeadQuarters = currentActiveBranch?.prefixCode === "HQ";

  const filteredNavMain = isHeadQuarters
    ? data.navMain
    : data.navMain.filter((item) => item.title !== "Company Profile");

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
              <a href="#">
                <img
                  className="h-12"
                  // src="/logo-removebg-preview.png"
                  src={logo}
                />
                {/* <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                  <span className="text-xl">M</span>
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">
                    MySoft E-Invoice
                  </span>
                  <span className="truncate text-xs">Version 0.2</span>
                </div> */}
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={filteredNavMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: user?.businessName ?? "",
            email: user?.userEmail ?? "",
            avatar: data.user.avatar,
          }}
        />
      </SidebarFooter>
    </Sidebar>
  );
}
